/* RESPONSIBLE TEAM: team-ai-insights */
import TopicTrends from 'embercom/routes/apps/app/automation/fin-ai-agent/analyze/topic-trends';

export default class FinStandaloneTopicTrends extends TopicTrends {
  analytics = {
    section: 'standalone',
    place: 'topic-trends',
  };

  templateName = 'apps/app/automation/fin-ai-agent/analyze/topic-trends';
  routeWhenNotOptedIn = 'apps.app.standalone.setup';
}
